import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"

const RedirectToHomePage = () => {
  const { role } = useSelector(state => state.userAccountInfo)

  const { search } = useLocation()

  if (role === "subscribeAdmin") {
    return <Navigate to="/products" />
  }

  const plan = new URLSearchParams(search).get("plan")

  if (role === "subscribeUser") {
    return <Navigate to={`/wizard${!!plan ? `?plan=${plan}` : ""}`} />
  }
}

export default RedirectToHomePage